
import React, { useState,useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCog, faEnvelopeOpen, faSearch, faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Row, Col, Nav, Form, Image, Navbar, Dropdown, Container, ListGroup, InputGroup } from '@themesberg/react-bootstrap';


import "../scss/fcsvendor/layout/_vendor.scss";
import { formatDistanceToNow } from 'date-fns';

import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import axios from "axios";
import { getNotifications ,getUserProfile} from "../app/api";
// import Profile3 from "../assets/img/team/profile-picture-3.jpg";
import Loader from "./Loader";

export default (props) => {
  const [notifications, setNotifications] = useState([]);

        const[page,setPage]=useState(1)
        const [totalPages, setTotalPages] = useState(0);
          const [loading, setLoading] = useState(true);
      
  // const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);
  const [userName, setUserName] = useState('');
  const handleLogout = () => {
    // Clear local storage
    localStorage.clear();
  
};

const fetchUser = async () => {
  try {
   
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    // console.log(user)
    const id=user.id

    const response = await axios.get(getUserProfile(id), {
      headers: {
        "secret-key": process.env.REACT_APP_SECRET_KEY,
        "auth-token": `Bearer ${token}`,
      },
    });
    console.log(response.data);
    setUserName(response.data?.name);
   

  } catch (error) {
    console.error("Error fetching vendors:", error);
  }
  
};
  const markNotificationsAsRead = () => {
    fetchNotifications();
    setTimeout(() => {
      setNotifications(notifications?.map(n => ({ ...n, read: true })));
    }, 300);
  };

  useEffect(() => {
    fetchUser()
  }, []);
  const fetchNotifications = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getNotifications(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
        },
      });
      console.log("notification",response.data);
     
      setNotifications(response.data?.data)
      setTotalPages(response.data?.pagination?.total_pages)
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
    finally {
      setLoading(false); // Hide loader after fetching data
    }
  
  };


useEffect(() => {

  

  fetchNotifications();
  }, []);
  const getRelativeTime = (timestamp) => {
    const date = new Date(timestamp);
    return formatDistanceToNow(date, { addSuffix: true });
  };

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-end w-100">
          {/* <div className="d-flex align-items-center">
            <Form className="navbar-search">
              <Form.Group id="topbarSearch">
                <InputGroup className="input-group-merge search-bar">
                  <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                  <Form.Control type="text" placeholder="Search" />
                </InputGroup>
              </Form.Group>
            </Form>
          </div> */}
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead} >
              <Dropdown.Toggle as={Nav.Link} className="text-dark icon-notifications me-lg-3">
                <span className="icon icon-sm">
                  <FontAwesomeIcon icon={faBell} className="bell-shake" />
                  {/* {areNotificationsRead ? null : <span className="icon-badge rounded-circle unread-notifications" />} */}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu  style={{top:"10%" ,right: "auto !important" }} className="dashboard-dropdown l-0 notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
                <ListGroup className="list-group-flush">
                  <Nav.Link href="#" className="text-center text-primary fw-bold border-bottom border-light py-3">
                    Notifications
                  </Nav.Link>
                  {notifications?.slice(0, 7).map((data) => (
                  <ListGroup.Item className="border-bottom border-light">
       {loading?(
        <Loader/>
       ):(
<Row className="align-items-center">
          <Col className="col-auto">
          
          </Col>
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="h6 mb-0 font-small">{data.details}</p>
              </div>
             
            </div>
            <div className="text-end">
                <small >{getRelativeTime(data.datetime)}</small>
              </div>
          </Col>
        </Row>
       )}
        
      </ListGroup.Item>
                  ))}
                  <Dropdown.Item className="text-center text-primary fw-bold py-3" as={Link} to={Routes.Notifications.path} >
                    View all
                  </Dropdown.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  {/* <Image src={Profile3} className="user-avatar md-avatar rounded-circle" /> */}
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <p className="mb-0 font-small fw-bold">{userName}</p>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu  className="user_dropdown2  mt-2">
               
              <Dropdown.Item as={Link} to="/settings" className="fw-bold" style={{ color: "black" }}>
  <FontAwesomeIcon style={{ color: "black" }} icon={faCog} className=" me-2" /> Settings
</Dropdown.Item>
              
               

                <Dropdown.Divider />

                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                 <Link as={Link} to={Routes.Signin.path}> <FontAwesomeIcon  icon={faSignOutAlt} className="text-danger me-2" />  Logout</Link>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
